// a list of tokens by chain
import { Currency, Token } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'

import {
  AAPLUS_DUCX_MAINNET,
  AAPLUS_DUCX_TESTNET,
  BULLION_DUCX_MAINNET,
  BULLION_DUCX_TESTNET,
  DUC_DUCX_MAINNET,
  DUC_DUCX_TESTNET,
  GOLDMV_DUCX_MAINNET,
  GOLDMV_DUCX_TESTNET,
  nativeOnChain,
  SHBT_DUCX_MAINNET,
  SHBT_DUCX_TESTNET,
  SHRES_DUCX_MAINNET,
  SHRES_DUCX_TESTNET,
  USDDUC_DUCX_MAINNET,
  USDDUC_DUCX_TESTNET,
  USDDUCX_DUCX_MAINNET,
  USDDUCX_DUCX_TESTNET,
  WRAPPED_NATIVE_CURRENCY,
  XGEN_DUCX_MAINNET,
  XGEN_DUCX_TESTNET,
} from './tokens'

type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

const WRAPPED_NATIVE_CURRENCIES_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WRAPPED_NATIVE_CURRENCY)
    .map(([key, value]) => [key, [value]])
    .filter(Boolean)
)

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  [SupportedChainId.DUCX]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.DUCX],
    USDDUC_DUCX_MAINNET,
    USDDUCX_DUCX_MAINNET,
    AAPLUS_DUCX_MAINNET,
    GOLDMV_DUCX_MAINNET,
    XGEN_DUCX_MAINNET,
    SHBT_DUCX_MAINNET,
    BULLION_DUCX_MAINNET,
    SHRES_DUCX_MAINNET,
    DUC_DUCX_MAINNET,
  ],
  [SupportedChainId.DUCX_TESTNET]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.DUCX_TESTNET],
    USDDUC_DUCX_TESTNET,
    USDDUCX_DUCX_TESTNET,
    AAPLUS_DUCX_TESTNET,
    GOLDMV_DUCX_TESTNET,
    XGEN_DUCX_TESTNET,
    SHBT_DUCX_TESTNET,
    BULLION_DUCX_TESTNET,
    SHRES_DUCX_TESTNET,
    DUC_DUCX_TESTNET,
  ],
}
export const ADDITIONAL_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.DUCX]: [nativeOnChain(SupportedChainId.DUCX), DUC_DUCX_MAINNET],
  [SupportedChainId.DUCX_TESTNET]: [nativeOnChain(SupportedChainId.DUCX_TESTNET), DUC_DUCX_TESTNET],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  [SupportedChainId.DUCX]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.DUCX]],
  [SupportedChainId.DUCX_TESTNET]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.DUCX_TESTNET]],
}
export const PINNED_PAIRS: { readonly [chainId: number]: [Token, Token][] } = {
  [SupportedChainId.DUCX]: [],
}
